import React, { useEffect, useState, useRef } from "react";
import { useFormikContext, getIn } from "formik";

const CustomAutoComplete = ({
  formik,
  field,
  label,
  searchFunction,
  width = "100%",
  required = true,
  descriptionField = "descripcion",
}) => {
  const [value, setValue] = useState("");
  const [options, setOptions] = useState([]);
  const [showOptions, setShowOptions] = useState(false);
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);
  const timeoutIdRef = useRef(null);
  // const formik = useFormikContext();
  const error =
    formik?.touched &&
    formik?.errors &&
    getIn(formik.touched, field) &&
    getIn(formik.errors, field);

  useEffect(() => {
    const selected = formik?.values?.[field];
    if (selected && selected.id && selected[descriptionField]) {
      setValue(selected);
      setText(`(${selected.id}) ${selected[descriptionField]}`);
    }
  }, [formik.values[field], descriptionField]);

  const handleChange = (event) => {
    const inputValue = event.target.value;
    setText(inputValue);

    if (timeoutIdRef.current) {
      clearTimeout(timeoutIdRef.current);
    }

    if (inputValue.trim() === "") {
      setOptions([]);
      setValue(null);
      formik.setFieldValue(field, null);
      setLoading(false);
      return;
    }

    setLoading(true);
    timeoutIdRef.current = setTimeout(async () => {
      try {
        const data = await searchFunction(inputValue);
        setOptions(data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    }, 500);
  };

  const handleSelect = async (data) => {
    //console.log(`[CustomAutoComplete] Selección en campo "${field}":`, data);

    setValue(data);
    setText(`(${data?.id}) ${data?.[descriptionField]}`);
    setShowOptions(false);
    await formik?.setFieldValue(field, data);// esperar a que cambie el valor
    formik?.setFieldTouched(field, true, true);
    formik?.validateField(field);
  };

  const clearSelection = () => {
    setText("");
    setValue(null);
    setOptions([]);
    setShowOptions(false);
    formik.setFieldValue(field, null);
  };

  const handleFocus = async () => {
    setShowOptions(true);
    if (text.trim() === "" && options.length === 0) {
      setLoading(true);
      try {
        const data = await searchFunction("");
        setOptions(data);
      } catch (error) {
        console.error("Error al cargar opciones:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleBlur = () => {
    setTimeout(() => setShowOptions(false), 150);
  };

  useEffect(() => {
    const initial = formik.values[field];
    if (initial && initial.id && !value?.id) {
      const fetchById = async () => {
        try {
          const results = await searchFunction(initial.id);
          const matched = results?.find((item) => item.id === initial.id);
          if (matched) {
            setValue(matched);
            setText(`(${matched.id}) ${matched[descriptionField]}`);
            formik.setFieldValue(field, matched); // asegura que esté completo
          }
        } catch (error) {
          console.error("Error buscando valor inicial:", error);
        }
      };
      fetchById();
    }
  }, [formik.values[field], field]);

  return (
    <div style={{ width }}>
      <div className="form-group">
        <label
          className="form-label"
          style={{ color: error ? "red" : "inherit", display: "block" }}
        >
          {label}
          {required && (
            <span style={{ color: error ? "red" : "inherit" }}> *</span>
          )}
        </label>
        <div style={{ position: "relative" }}>
          {loading && (
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "10px",
                transform: "translateY(-50%)",
                zIndex: 2,
              }}
            >
              <span
                className="spinner-border spinner-border-sm text-primary"
                role="status"
              />
            </div>
          )}

          {text && (
            <button
              type="button"
              onClick={clearSelection}
              style={{
                position: "absolute",
                right: "27px",
                top: "50%",
                transform: "translateY(-50%)",
                background: "none",
                border: "none",
                color: "#999",
                cursor: "pointer",
                zIndex: 2,
                padding: 0,
                lineHeight: 1,
              }}
            >
              <i className="fa fa-times" />
            </button>
          )}

          <input
            type="text"
            className={`form-control ${error ? "is-invalid" : ""}`}
            placeholder={`Buscar ${label}`}
            value={text}
            onChange={handleChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
            autoComplete="password"
            style={{
              paddingLeft: loading ? "2rem" : undefined,
              paddingRight: text ? "2rem" : undefined,
            }}
          />

          {options.length > 0 && showOptions && (
            <ul
              className="list-group mt-2"
              style={{
                position: "absolute",
                zIndex: 1000,
                backgroundColor: "white",
                width: "100%",
                maxHeight: "200px",
                overflowY: "auto",
                border: "1px solid #ccc",
              }}
            >
              {options.map((data, index) => (
                <li
                  key={index}
                  className="list-group-item list-group-item-action"
                  onMouseDown={() => handleSelect(data)}
                >
                  ({data?.id}) {data?.[descriptionField]}
                </li>
              ))}
            </ul>
          )}

          {options.length === 0 && showOptions && !loading && (
            <ul
              className="list-group"
              style={{
                position: "absolute",
                zIndex: 1000,
                backgroundColor: "white",
                width: "100%",
                maxHeight: "200px",
                overflowY: "auto",
                border: "1px solid #ccc",
                top: "100%",
                marginTop: "0.25rem",
              }}
            >
              <li className="list-group-item list-group-item-action">
                No hay resultados
              </li>
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomAutoComplete;
